exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MarkBanner_component_1PxC {\n  display: none;\n}\n\n@media (max-width: 767px) {\n\n  .MarkBanner_component_1PxC {\n    margin: 0 -4px;\n    display: block;\n    -webkit-box-flex: 1;\n    -webkit-flex-grow: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.MarkBanner_image_3EZz {\n  pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"component": "MarkBanner_component_1PxC",
	"image": "MarkBanner_image_3EZz"
};